import { Box } from '@material-ui/core';
import React from 'react';
import { NavLink } from 'react-router-dom';
import CmtImage from '../../../../@coremat/CmtImage';

const FooterLogo = ({ color, ...props }) => {
  const logoUrl = color === 'white' ? '/images/logo-copy.png' : '/images/logo-copy.png';

  return (
    <Box className="pointer" {...props}>
      <NavLink to="/">
        <CmtImage src={logoUrl} alt="logo" style={{ width: 30 }} />
      </NavLink>
    </Box>
  );
};

export default FooterLogo;
